// import axios from 'axios';
import shortid from 'shortid';
import { ToastifyMessage } from 'Elements';
import { cssTransition, toast } from 'react-toastify';

export const isEqualArr = (arr) => arr.every((val) => val === undefined);

export const isBlank = (str) => !str || /^\s*$/.test(str);

export const isClient = () => typeof window !== 'undefined';

export const encodeData = (json) => {
	var params = [];
	for (var key in json) {
		params.push(
			encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
		);
	}
	return params.join('&');
};

export const slugify = (str) => {
	if (str) {
		return str
			.toString()
			.toLowerCase()
			.replace(/\s+/g, '-') // Replace spaces with -
			.replace(/-+/g, '-') // Replace multiple - with single -
			.replace(/^-+/, '') // Trim - from start of text
			.replace(/-+$/, ''); // Trim - from end of text
	}
};

const slide = cssTransition({
	enter: 'animate__slideIn',
	exit: 'animate__slideOut'
});

export const toastify = (message, type = 'error', userOptions = {}) => {
	let typeCast = {
		success: toast.TYPE.SUCCESS,
		error: toast.TYPE.ERROR,
		warn: toast.TYPE.WARNING,
		info: toast.TYPE.INFO
	};
	// const uniqueId = new Date();
	const defaultOption = {
		position: 'top-center',
		hideProgressBar: true,
		autoClose: 4000,
		type: typeCast[type],
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		transition: slide,
		toastId: shortid.generate()
	};
	let toastifyOption = { ...defaultOption, ...userOptions };
	return toast(
		<ToastifyMessage message={message} type={type} />,
		toastifyOption
	);
};

export const hasVScroll =
	document.body.scrollHeight > document.body.clientHeight;

export const highlightWord = (query, results) => {
	const term = query; // search query we want to highlight in results
	const search_results = results; // search results
	const regex = new RegExp(term, 'g');

	return search_results.replace(
		regex,
		(match) => `<span class="highlight-word">${match}</span>`
	);
};

export const withHttpLink = (url) => {
	return !/^https?:\/\//i.test(url) ? 'http://' + url : url;
};

export const urlify = (text) => {
	let urlRegex = /(https?:\/\/[^\s]+)/g;
	return text.replace(urlRegex, function (url) {
		return '<a href="' + url + '">' + url + '</a>';
	});
	// or alternatively
	// return text.replace(urlRegex, '<a href="$1">$1</a>')
};

export const setStorage = (name, value, type = 'local') => {
	let action = null;
	if (isClient()) {
		switch (type) {
			case 'session':
				action = sessionStorage.setItem(name, value);
				break;
			case 'local':
				action = localStorage.setItem(name, value);
				break;
			default:
				action = localStorage.setItem(name, value);
				break;
		}
	}
	isClient() && action;
};

export const getStorage = (name, type = 'local', parseString = false) => {
	let action = null;
	if (isClient()) {
		switch (type) {
			case 'local':
				action = parseString
					? JSON.parse(localStorage.getItem(name))
					: localStorage.getItem(name);
				break;
			case 'session':
				action = parseString
					? JSON.parse(sessionStorage.getItem(name))
					: sessionStorage.getItem(name);
				break;
			default:
				action = parseString
					? JSON.parse(localStorage.getItem(name))
					: localStorage.getItem(name);
				break;
		}
	}
	return (isClient() && action) || {};
};

/* Site Utils */
export const isObjEmpty = (obj) => {
	for (let i in obj) return false;
	return true;
};

export const formatBytes = (bytes, decimals = 2) => {
	if (0 === bytes) return '0 Bytes';
	const dm = 0 > decimals ? 0 : decimals,
		d = Math.floor(Math.log(bytes) / Math.log(1024));
	return (
		['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'][d] +
		' ' +
		parseFloat((bytes / Math.pow(1024, d)).toFixed(dm))
	);
};

export function clamp(value, min, max) {
	return Math.min(Math.max(value, min), max);
}

export const getScrollPosition = (el = window) => ({
	x: el.pageXOffset !== undefined ? el.pageXOffset : el.scrollLeft,
	y: el.pageYOffset !== undefined ? el.pageYOffset : el.scrollTop
});

// Return immutable object
export const updateObj = (oldObj, updatedVal) => {
	return {
		...oldObj,
		...updatedVal
	};
};

// Return first letter capital for the strings
export const capitalize = (s) => (s && s[0].toUpperCase() + s.slice(1)) || '';

// Return truthy classes
export const clx = (...classes) => {
	return classes.filter(Boolean).join(' ');
};
